'use client';

import { useState, useEffect } from 'react';

const DarkModeSwitcher = () => {
  const [isDarkMode, setIsDarkMode] = useState(false);

  useEffect(() => {
    const isDarkModeEnabled = document.documentElement.classList.contains('dark');
    setIsDarkMode(isDarkModeEnabled);
  }, []);

  useEffect(() => {
    if (isDarkMode) {
      document.documentElement.classList.add('dark');
      document.documentElement.classList.remove('light');
      localStorage.setItem('darkMode', 'true');
    } else {
      document.documentElement.classList.add('light');
      document.documentElement.classList.remove('dark');
      localStorage.setItem('darkMode', 'false');
    }
  }, [isDarkMode]);

  const toggleDarkMode = () => {
    setIsDarkMode(prev => !prev);
  };

  return (
    <div className="btn-container">
      <label className="switch btn-color-mode-switch">
        <input
          value="1"
          id="color_mode"
          name="color_mode"
          type="checkbox"
          checked={isDarkMode}
          onChange={toggleDarkMode}
        />
        <label
          className="btn-color-mode-switch-inner"
          data-off="Light"
          data-on="Dark"
          htmlFor="color_mode"
        ></label>
      </label>
    </div>
  );
};

export default DarkModeSwitcher;
